import { useQuery } from 'react-query';
import { AdminLandingPageResponse, ApiError } from 'src/modules/generated-api-clients/sql';
import { useApiSqlContext } from 'src/modules/contexts/ApiSqlContext';
import { useAuthenticator } from '@aws-amplify/ui-react';

export const useLandingSummary = () => {
	const { client } = useApiSqlContext();
	const { user } = useAuthenticator(context => [context.user]);

	const token = user.getSignInUserSession()?.getIdToken().getJwtToken();

	return useQuery<AdminLandingPageResponse, ApiError>(
		['getAdminPortalHomeLandingSummary', token],
		async () => {
			try {
				if (!client) {
					throw new Error('API client is not initialized');
				}

				// if (user.attributes === undefined) {
          if (token === undefined) {
					throw new Error('AWS Amplify user attributes cannot be undefined');
				}

				// const response = await client.default.getAdminPortalHomeLandingSummary(user.attributes.email);
				const response = await client.default.getAdminPortalHomeLandingSummary(token);

				return response;
			} catch (error: unknown) {
				if (error instanceof ApiError) {
					console.error(
						`ApiError -> URL: ${error.url}\nSTATUS: ${error.status}\nMESSAGE: ${
							error.message
						}\nBODY: ${JSON.stringify(error.body)}`
					);
					throw error;
				} else {
					console.error('Error fetching account information:', error);
					throw error;
				}
			}
		},
		{
			// enabled: !!user.attributes?.email
      enabled: !!token
		}
	);
};
